export const ENV_CONFIG = '/config.json';
export const CONTENT_URL = './_locale/en-GB/newapp.content.json';
export const STATIC_URL = './static/product/config/document-list-locator.json';
